module.exports = __webpack_public_path__ + "static/media/808startstop.de16f6f0.mp3";